class ProductsAdapterService {
  constructor(client, source, cache_products = false) {
    this.client = client;
    this.source = source;
    this.cache_products = cache_products;
  }

  adaptProduct(product) {
    // If already adapted
    if (product.source_product) {
      return product;
    }

    switch (this.source) {
      case 'ShopifyGraphql':
        return new ProductsShopifyAdapter(product);
      case 'Shopify':
        return new ProductsShopifyAjaxAdapter(product);
      case 'Convertflow':
        return new ProductsConvertflowAdapter(product);
      default:
        break;
    }
  }

  createCart() {
    return new Promise((resolve, reject) => {
      this.client.cartCreate().then((cart) => {
        resolve(cart)
      }).catch(reject)
    })
  }

  addToCart(cartId, products) {
    return new Promise((resolve, reject) => {
      if (window.convertflow?.session?.cart?.Shopify?.adding_to_cart !== true) {
        const productsIntegrationService = new ProductsIntegrationsService("Shopify");

        let cart_session = { adding_to_cart: true }
        productsIntegrationService.saveOnCartSession("Shopify", cart_session);

        this.client.cartAddProduct(cartId, products).then((cart) => {
          $cf.ajax({
            type: "GET",
            url: `/?cf_action=cf_shopify_cart&cart_id=${cart?.id}`,
            dataType: "json",
            success: function (data) {},
          });

          if (cart?.lines?.length > 0) {
            cart_session = { ...cart_session, ...cart };

            let cartSessionProductIDS = convertflow.session.cart.Shopify.cf_products_quantities || [];
            cart.lines.forEach((line) => {
              cartSessionProductIDS.push(`${line.id.replace('gid://shopify/ProductVariant/', '')}:${line.quantity}`)
            });
            cart_session = { ...cart_session, cf_products_quantities: cartSessionProductIDS };
          }

          cart_session.adding_to_cart = false;
          productsIntegrationService.saveOnCartSession("Shopify", cart_session);

          resolve(cart)
        }).catch(reject)
      } else {
        let interval = setInterval(() => {
          if (window.convertflow?.session?.cart?.Shopify?.adding_to_cart !== true) {
            clearInterval(interval);
            this.addToCart(cartId, products).then(resolve).catch(reject);
          }
        }, 100);
      }
    })
  }

  removeFromCart(cartId, products) {
    return new Promise((resolve, reject) => {
      const productsIntegrationService = new ProductsIntegrationsService("Shopify");

      this.client.cartRemoveProduct(cartId, products).then((cart) => {
        cart.adding_to_cart = false;
        productsIntegrationService.saveOnCartSession("Shopify", cart);

        $cf.ajax({
          type: "GET",
          url: `/?cf_action=cf_shopify_cart&cart_id=${cart?.id}`,
          dataType: "json",
          success: function (data) {},
        });

        resolve(cart)
      }).catch(reject)
    })
  }

  updateCartLineQuantity(cartId, lineId, variantId, quantity) {
    return new Promise((resolve, reject) => {
      if (window.convertflow?.session?.cart?.Shopify?.adding_to_cart !== true) {
        const productsIntegrationService = new ProductsIntegrationsService("Shopify");

        let cart_session = { adding_to_cart: true }
        productsIntegrationService.saveOnCartSession("Shopify", cart_session);

        this.client.cartUpdateLineQuantity(cartId, lineId, variantId, quantity).then((cart) => {
          $cf.ajax({
            type: "GET",
            url: `/?cf_action=cf_shopify_cart&cart_id=${cart?.id}`,
            dataType: "json",
            success: function (data) {},
          });

          const cartLines = (cart && cart.lines) || [];
          cart_session = { ...cart_session, ...cart, lines: cartLines };
          cart_session.cf_products_quantities = cartLines.map(
            (line) => `${line.id.replace('gid://shopify/ProductVariant/', '')}:${line.quantity}`
          );

          cart_session.adding_to_cart = false;
          productsIntegrationService.saveOnCartSession("Shopify", cart_session);

          resolve(cart)
        }).catch((error) => {
          cart_session.adding_to_cart = false;
          productsIntegrationService.saveOnCartSession("Shopify", cart_session);
          reject(error);
        })
      } else {
        let interval = setInterval(() => {
          if (window.convertflow?.session?.cart?.Shopify?.adding_to_cart !== true) {
            clearInterval(interval);
            this.updateCartLineQuantity(cartId, lineId, variantId, quantity).then(resolve).catch(reject);
          }
        }, 100);
      }
    })
  }

  applyDiscountCode = async (cartId, discountCode) => {
    return new Promise((resolve, reject) => {
      if (window.convertflow?.session?.cart?.Shopify?.adding_to_cart !== true) {
        const productsIntegrationService = new ProductsIntegrationsService("Shopify");

        let cart_session = { adding_to_cart: true }
        productsIntegrationService.saveOnCartSession("Shopify", cart_session);

        this.client.cartApplyDiscountCode(cartId, discountCode).then((cart) => {
          productsIntegrationService.saveOnCartSession("Shopify", cart);

          $cf.ajax({
            type: "GET",
            url: `/?cf_action=cf_shopify_cart&cart_id=${cart?.id}`,
            dataType: "json",
            success: function (data) {},
          });

          cart_session.adding_to_cart = false;
          productsIntegrationService.saveOnCartSession("Shopify", cart_session);

          resolve(cart)
        }).catch(reject)
      } else {
        let interval = setInterval(() => {
          if (window.convertflow?.session?.cart?.Shopify?.adding_to_cart !== true) {
            clearInterval(interval);
            this.applyDiscountCode(cartId, discountCode).then(resolve).catch(reject);
          }
        }, 100);
      }
    })
  }

  updateCartAttributes = async (cartId, attributes) => {
    return new Promise((resolve, reject) => {
      this.client.cartUpdateAttributes(cartId, attributes).then((cart) => {
        resolve(cart)
      }).catch(reject)
    })
  }

  getProduct(handle, variantId = null) {
    return new Promise((resolve, reject) => {
      const product = this.getProductFromCache(handle);
      if (product) {
        resolve(product)
      }

      this.client.getProduct(handle).then((product) => {
        if (product) {
          let adaptedProduct = this.adaptProduct(product);

          if (this.cache_products == true) {
            this.saveOnCache([adaptedProduct]);
          }

          if (variantId) {
            let variant = adaptedProduct.variants.find((variant) => variant.id == variantId);
            resolve(variant)
          } else {
            resolve(adaptedProduct)
          }
        } else {
          reject("Product not found")
        }
      }).catch(reject)
    })
  }

  getProducts(args) {
    return new Promise((resolve, reject) => {
      const batchCallback = this.cache_products == true ? this.saveOnCache : undefined;

      this.client.getProducts(args, [], undefined, 0, batchCallback).then((products) => {
        products = products.map((product) => {
          return this.adaptProduct(product);
        })

        resolve(products)
      }).catch(reject)
    })
  }

  getCollectionProducts(id, args) {
    return new Promise((resolve, reject) => {
      this.client.getCollectionProducts(id, args).then((products) => {
        if (products) {
          products = products.map((product) => {
            return this.adaptProduct(product);
          })

          if (this.cache_products == true) {
            this.saveOnCache(products);
          }

          resolve(products)
        } else {
          resolve([])
        }
      }).catch(reject)
    })
  }

  getProductRecommendations(productId, args) {
    return new Promise((resolve, reject) => {
      this.client.getProductRecommendations(productId, args).then((products) => {
        products = products.map((product) => {
          return this.adaptProduct(product);
        })

        if (this.cache_products == true) {
          this.saveOnCache(products);
        }

        resolve(products)
      }).catch(reject)
    })
  }

  getProductFromCache(handle) {
    if (
      typeof window !== 'undefined' &&
      typeof window.convertflow == 'undefined' &&
      typeof window.cf_shopify_products !== 'undefined'
    ) {
      const product = window.cf_shopify_products.find((product) => product.handle == handle);
      return product;
    }
  }

  saveOnCache(products) {
    if (typeof window !== 'undefined' && typeof window.convertflow == 'undefined') {
      const windowProducts = window.cf_shopify_products || [];
      const uniqueProducts = [
        ...new Map(
          [...products, ...windowProducts].map((item) => [item.id, item])
        ).values(),
      ].sort((a, b) => a.title.localeCompare(b.title));

      window.cf_shopify_products = uniqueProducts;

      dispatchCustomEvent("cf_shopify_products_change", {
        products: window.cf_shopify_products,
      });
    }
  }
}

if (typeof window !== 'undefined' && typeof window.convertflow == 'undefined') {
  window.ProductsAdapterService = ProductsAdapterService;
}
